import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map, shareReplay, } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PermissionService = /** @class */ (function (_super) {
    tslib_1.__extends(PermissionService, _super);
    function PermissionService(http) {
        var _this = _super.call(this, http, MapperService.permissionMap) || this;
        _this._endpoint = '/odata/Permissions';
        _this.getPermissions = function () {
            return _super.prototype.get.call(_this).pipe(map(function (r) { return r.data.filter(function (p) { return p.name.includes('.'); }); }), shareReplay(1));
        };
        return _this;
    }
    PermissionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PermissionService_Factory() { return new PermissionService(i0.ɵɵinject(i1.HttpClient)); }, token: PermissionService, providedIn: "root" });
    return PermissionService;
}(ODataService));
export { PermissionService };
